'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import clsx from 'clsx';

import { formatCategoryUrl, removeLastTrailingSlash } from 'services/lib/util';
// Pamiętaj o imporcie stylów Swipera, jeśli nie są importowane globalnie
import 'swiper/css';
import 'swiper/css/navigation';

const determineActiveRoute = (route, pathname) => {
  if (!route || !pathname) return false;
  const formattedRoute = removeLastTrailingSlash(formatCategoryUrl(route));
  const formattedPathname = removeLastTrailingSlash(pathname);

  return formattedRoute === formattedPathname;
};

const determineCurrentElement = (dataset, pathname) => {
  let foundElementIndex = 0;
  if (Array.isArray(dataset) && dataset != null) {
    dataset.forEach((item, index) => {
      const formattedRoute = removeLastTrailingSlash(formatCategoryUrl(item.node.uri));
      const formattedPathname = removeLastTrailingSlash(pathname);
      if (formattedRoute === formattedPathname) {
        foundElementIndex = index;
      }
    });
  }
  return foundElementIndex === 0 ? foundElementIndex : foundElementIndex + 1;
};

export const CategoryNavigation = ({ nodeByUri }) => {
  const pathname = usePathname();

  // Guard clause
  if (!nodeByUri) return null;

  const filteredCategories = nodeByUri.children?.edges?.filter((category) => category.node.count != null) || [];

  const initialSlide = determineCurrentElement(filteredCategories, pathname);
  const isAllActive = determineActiveRoute(nodeByUri.uri, pathname);

  return (
    <div className="categoryNavBar w-full px-0">
      <nav className="px-0">
        <ul className="m-0 list-none p-0 px-0">
          <Swiper
            modules={[Navigation]}
            spaceBetween={16}
            slidesPerView="auto"
            slideToClickedSlide={true}
            navigation
            initialSlide={initialSlide}
            className="px-0"
          >
            <SwiperSlide key="all" className={clsx('item px-0', isAllActive && 'swiper-slide-active')}>
              <li className={clsx('all px-0', isAllActive && 'active')}>
                <Link className="px-0" href={formatCategoryUrl(nodeByUri.uri)}>
                  Wszystkie
                </Link>
              </li>
            </SwiperSlide>

            {filteredCategories.map((category) => {
              const isActive = determineActiveRoute(category.node.uri, pathname);

              return (
                <SwiperSlide key={category.node.id} className={clsx('item px-0', isActive && 'swiper-slide-active')}>
                  <li className={clsx('px-0', isActive && 'active')}>
                    <Link className="px-0" href={formatCategoryUrl(category.node.uri)}>
                      {category.node.name}
                    </Link>
                  </li>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </ul>
      </nav>
    </div>
  );
};
